import { IV2CheckPriceResponse } from 'shared/repositories/dailyrent/entities/response/V2CheckPriceResponse';

import { ITypedReduxAction } from '../../types/redux';

export enum ECheckDailyrentPriceActionTypes {
  Loading = 'checkDailyrentPrice/loading',
  Success = 'checkDailyrentPrice/success',
  Fail = 'checkDailyrentPrice/fail',
}

export type TLoading = ITypedReduxAction<ECheckDailyrentPriceActionTypes.Loading, boolean>;
export type TSuccess = ITypedReduxAction<ECheckDailyrentPriceActionTypes.Success, IV2CheckPriceResponse>;
export type TFail = ITypedReduxAction<ECheckDailyrentPriceActionTypes.Fail, string>;

export type TCheckDailyrentPriceActions = TLoading | TSuccess | TFail;
